export const environment: {production: boolean, VERSION: string} = {
  production: true,
  VERSION: require('../../package.json').version
};



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/environments/environment.ts